<div class="addlocation-subselection">
  <div class="district-heading">{{ selectedFilter | titlecase }}</div>
  <div class="selection">
    <div class="subselection-header"></div>
    @if (subSectionList && subSectionList.length > 0) {
      <span class="filter-labels">
        <mat-checkbox
          (change)="selectAll($event)"
          [disabled]="InputLength > 1"
          [checked]="selectAllFields"
          class="select-all-checkbox"
          >
          {{ 'shared.selectAll' | translate }}
        </mat-checkbox>
        @if (selectedFilter()) {
          <div class="filter-section">
            @for (data of subSectionList();  track data) {
              <div class="filter-labels">
                <mat-checkbox
                  [(ngModel)]="data.checked"
                  (change)="onSelectionChange(data, $event)"
                  [checked]="selectAllFields || data.checked"
                  [disabled]="InputLength > 1"
                  >
                  {{ data.value | titlecase }}
                </mat-checkbox>
              </div>
            }
          </div>
        }
      </span>
    } @else {
      <span class="norecords"> {{ 'shared.noRecords' | translate }}</span>
    }
  </div>
</div>
